// Multi-language translations for CryptoVIP Club
// SEO-Optimized URL Structure (Google 2025-2026 Guidelines)

export const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English", country: "GLOBAL", flag: "🇬🇧", path: "/en" },
  { code: "de", name: "Deutsch", country: "DE", flag: "🇩🇪", path: "/de" },
  { code: "nl", name: "Nederlands", country: "NL", flag: "🇳🇱", path: "/nl" },
  { code: "en-ca", name: "English (Canada)", country: "CA", flag: "🇨🇦", path: "/en-ca" },
  { code: "da", name: "Dansk", country: "DK", flag: "🇩🇰", path: "/da" },
];

export const translations = {
  // ============ ENGLISH (GLOBAL - DEFAULT) ============
  en: {
    meta: {
      title: "CryptoVIP Club | First VIP Deal Negotiators Crypto Casinos",
      description: "We negotiate VIP deals with top crypto casinos for you. Get personalized cashback rates, exclusive bonus codes, and custom VIP perks. Free service.",
      keywords: "crypto casino VIP, casino negotiation, VIP bonus codes, personalized casino deals, crypto cashback",
    },
    header: {
      topCasinos: "Top Casinos",
      guides: "Guides",
      faq: "FAQ",
      blog: "Blog",
      joinVip: "Join VIP Club",
    },
    hero: {
      badge: "WORLD'S FIRST VIP CASINO NEGOTIATORS",
      title1: "We Negotiate With Casinos",
      titleHighlight: "So You Don't Have To",
      subtitle: "Tell us the cashback rate you want, the VIP perks you deserve, and we'll negotiate directly with top crypto casinos to make it happen. No middleman fees. Just better deals.",
      exploreCasinos: "See How It Works",
      readGuides: "VIP Benefits",
      trustBadges: {
        partnerships: "Direct Casino Partnerships",
        vipDeals: "Personalized VIP Deals",
        freeService: "100% Free Service"
      },
    },
    howItWorks: {
      sectionTitle: "How We Get You",
      sectionHighlight: "Better Deals",
      step1Title: "Tell Us What You Want",
      step1Desc: "Share your desired cashback rate, bonus preferences, and VIP perks. Be specific - the more details, the better deal we can negotiate.",
      step2Title: "We Negotiate For You",
      step2Desc: "Our team contacts casino VIP managers directly. We leverage our network and volume to secure exclusive terms.",
      step3Title: "Get Your Custom Deal",
      step3Desc: "Receive your personalized VIP package with exclusive bonuses, higher limits, and perks tailored to your playing style.",
      whyTitle: "Why Negotiate Through Us?",
      directAccess: "Direct Access",
      directAccessDesc: "We have direct relationships with casino VIP managers",
      negotiationPower: "Negotiation Power",
      negotiationPowerDesc: "Our volume gives us leverage individual players don't have",
      industryExpertise: "Industry Expertise",
      industryExpertiseDesc: "We know what deals are possible (and what to ask for)",
      zeroCost: "Zero Cost",
      zeroCostDesc: "100% free Negotiation Service",
      responseTime: "Average response time",
      startNegotiating: "Start Negotiating"
    },
    quiz: {
      badge: "Personalized Quiz • 60 seconds",
      title: "Find Your",
      titleHighlight: "Perfect Deal",
      description: "Answer 4 quick questions and we'll show you what type of VIP you are.",
      highRoller: "High Roller",
      highRollerDesc: "Big bets, big rewards",
      casualPro: "Casual Pro",
      casualProDesc: "Smart plays, steady wins",
      tournamentKing: "Tournament King",
      tournamentKingDesc: "Competition lover",
      startQuiz: "Start the Quiz",
      trustNote: "100% free • No commitment • Your data is safe"
    },
    vipBenefits: {
      sectionTitle: "Why Join the",
      sectionHighlight: "VIP Club",
      bonusCodes: "Exclusive Bonus Codes",
      bonusCodesDesc: "Get access to bonus codes not available anywhere else.",
      earlyAccess: "Early Access",
      earlyAccessDesc: "Be the first to know about new crypto casinos.",
      vipDeals: "Members-Only VIP Deals",
      vipDealsDesc: "Exclusive negotiations with casino VIP managers.",
      community: "Community & Tips",
      communityDesc: "Join our private community of crypto casino enthusiasts.",
      alerts: "Casino Alerts",
      alertsDesc: "Instant notifications about new bonuses and promotions.",
      support: "Priority Support",
      supportDesc: "Direct line to our team for any questions.",
      joinCta: "Join 45,000+ Club Members",
      joinButton: "Join Free Now"
    },
    crypto: {
      title: "Supported Cryptocurrencies"
    },
    stats: {
      title: "Trusted by Thousands of Players",
      provablyFair: "Provably Fair Verified",
      instantWithdrawals: "Instant Crypto Withdrawals",
      licensedOnly: "Licensed Casinos Only"
    },
    guides: {
      subtitle: "Knowledge Base",
      title: "Crypto Casino",
      titleHighlight: "Guides",
      description: "Expert tutorials and strategies for crypto casino players."
    },
    spokes: {
      subtitle: "Latest Articles",
      title: "From the",
      titleHighlight: "Blog",
      description: "Expert insights and strategies from our blog."
    },
    faq: {
      subtitle: "Got Questions?",
      title: "Frequently Asked",
      titleHighlight: "Questions",
    },
    blog: {
      subtitle: "Latest Guides",
      title: "Crypto Casino",
      titleHighlight: "Articles",
      readMore: "Read Article",
      viewAll: "View All Guides",
      minRead: "min read",
      description: "Expert guides and strategies for crypto casino players."
    },
    newsletter: {
      title: "Join the",
      titleHighlight: "VIP",
      title2: "Newsletter",
      description: "Get exclusive casino bonuses, crypto tips, and VIP-only deals.",
      placeholder: "your@email.com",
      button: "Join VIP",
      success: "You're in! Check your inbox.",
      noSpam: "No spam, ever. Unsubscribe anytime.",
    },
    footer: {
      tagline: "The premier destination for crypto gambling guides and responsible gaming.",
      navigation: "Navigation",
      resources: "Resources",
      legal: "Legal",
      home: "Home",
      aboutUs: "About Us",
      contact: "Contact Us",
      cryptoGuide: "Crypto Casino Guides",
      blog: "Blog",
      faq: "FAQ",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      responsibleGambling: "Responsible Gambling",
      affiliateDisclosure: "Affiliate Disclosure",
      company: "Company",
      ourTeam: "Our Expert Team",
      methodology: "How We Review",
      editorialGuidelines: "Editorial Guidelines",
      copyright: "CryptoVIP Club. All rights reserved.",
      gamblingWarning: "Gambling involves risk. Please gamble responsibly. 18+",
    },
  },

  // ============ GERMAN (GERMANY) ============
  de: {
    meta: {
      title: "CryptoVIP Club | Erste VIP-Deal Verhandler für Krypto Casinos",
      description: "Wir verhandeln VIP-Deals mit Top Krypto-Casinos für Sie. Personalisierte Cashback-Raten, exklusive Bonuscodes und maßgeschneiderte VIP-Vorteile. 100% kostenloser Service.",
      keywords: "krypto casino VIP, casino verhandlung, VIP bonus codes, personalisierte casino deals, krypto cashback",
    },
    header: {
      topCasinos: "Top Casinos",
      guides: "Ratgeber",
      faq: "FAQ",
      blog: "Blog",
      joinVip: "VIP Club Beitreten",
    },
    hero: {
      badge: "WELTWEIT ERSTE VIP CASINO VERHANDLER",
      title1: "Wir Verhandeln Mit Casinos",
      titleHighlight: "Damit Sie Es Nicht Müssen",
      subtitle: "Sagen Sie uns, welchen Cashback-Satz Sie möchten, welche VIP-Vorteile Sie verdienen, und wir verhandeln direkt mit den besten Krypto-Casinos. Keine Vermittlungsgebühren. Nur bessere Deals.",
      exploreCasinos: "So Funktioniert Es",
      readGuides: "VIP Vorteile",
      trustBadges: {
        partnerships: "Direkte Casino-Partnerschaften",
        vipDeals: "Personalisierte VIP-Deals",
        freeService: "100% Kostenloser Service"
      },
    },
    howItWorks: {
      sectionTitle: "Wie Wir Ihnen",
      sectionHighlight: "Bessere Deals Verschaffen",
      step1Title: "Sagen Sie Uns, Was Sie Wollen",
      step1Desc: "Teilen Sie Ihren gewünschten Cashback-Satz, Bonuspräferenzen und VIP-Vorteile mit. Je mehr Details, desto besser der Deal.",
      step2Title: "Wir Verhandeln Für Sie",
      step2Desc: "Unser Team kontaktiert Casino-VIP-Manager direkt. Wir nutzen unser Netzwerk, um exklusive Konditionen zu sichern.",
      step3Title: "Erhalten Sie Ihren Persönlichen Deal",
      step3Desc: "Erhalten Sie Ihr personalisiertes VIP-Paket mit exklusiven Boni, höheren Limits und Vorteilen.",
      whyTitle: "Warum Über Uns Verhandeln?",
      directAccess: "Direkter Zugang",
      directAccessDesc: "Wir haben direkte Beziehungen zu Casino-VIP-Managern",
      negotiationPower: "Verhandlungsstärke",
      negotiationPowerDesc: "Unser Volumen gibt uns Hebelwirkung",
      industryExpertise: "Branchenexpertise",
      industryExpertiseDesc: "Wir wissen, welche Deals möglich sind",
      zeroCost: "Keine Kosten",
      zeroCostDesc: "100% kostenloser Verhandlungsservice",
      responseTime: "Durchschnittliche Antwortzeit",
      startNegotiating: "Verhandlung Starten"
    },
    quiz: {
      badge: "Personalisiertes Quiz • 60 Sekunden",
      title: "Finden Sie Ihren",
      titleHighlight: "Perfekten Deal",
      description: "Beantworten Sie 4 schnelle Fragen und wir zeigen Ihnen, welcher VIP-Typ Sie sind.",
      highRoller: "High Roller",
      highRollerDesc: "Große Einsätze, große Belohnungen",
      casualPro: "Casual Pro",
      casualProDesc: "Kluges Spiel, stetige Gewinne",
      tournamentKing: "Turnier-König",
      tournamentKingDesc: "Wettbewerbsliebhaber",
      startQuiz: "Quiz Starten",
      trustNote: "100% kostenlos • Keine Verpflichtung • Ihre Daten sind sicher"
    },
    vipBenefits: {
      sectionTitle: "Warum Dem",
      sectionHighlight: "VIP Club Beitreten",
      bonusCodes: "Exklusive Bonuscodes",
      bonusCodesDesc: "Zugang zu Bonuscodes, die nirgendwo anders verfügbar sind.",
      earlyAccess: "Früher Zugang",
      earlyAccessDesc: "Erfahren Sie als Erster von neuen Krypto-Casinos.",
      vipDeals: "Nur-Mitglieder VIP-Deals",
      vipDealsDesc: "Exklusive Verhandlungen mit Casino-VIP-Managern.",
      community: "Community & Tipps",
      communityDesc: "Treten Sie unserer privaten Community bei.",
      alerts: "Casino-Benachrichtigungen",
      alertsDesc: "Sofortige Benachrichtigungen über neue Boni.",
      support: "Prioritäts-Support",
      supportDesc: "Direkter Draht zu unserem Team.",
      joinCta: "Treten Sie 45.000+ Club-Mitgliedern Bei",
      joinButton: "Kostenlos Beitreten"
    },
    crypto: {
      title: "Unterstützte Kryptowährungen"
    },
    stats: {
      title: "Vertraut von Tausenden von Spielern",
      provablyFair: "Provably Fair Verifiziert",
      instantWithdrawals: "Sofortige Krypto-Auszahlungen",
      licensedOnly: "Nur Lizenzierte Casinos"
    },
    guides: {
      subtitle: "Wissensdatenbank",
      title: "Krypto Casino",
      titleHighlight: "Ratgeber",
      description: "Expertenanleitungen und Strategien für Krypto-Casino-Spieler."
    },
    spokes: {
      subtitle: "Neueste Artikel",
      title: "Aus dem",
      titleHighlight: "Blog",
      description: "Experteneinblicke und Strategien aus unserem Blog."
    },
    faq: {
      subtitle: "Fragen?",
      title: "Häufig Gestellte",
      titleHighlight: "Fragen",
    },
    blog: {
      subtitle: "Neueste Ratgeber",
      title: "Krypto Casino",
      titleHighlight: "Artikel",
      readMore: "Artikel Lesen",
      viewAll: "Alle Ratgeber Anzeigen",
      minRead: "Min. Lesezeit",
      description: "Expertenanleitungen und Strategien für Krypto-Casino-Spieler."
    },
    newsletter: {
      title: "Treten Sie Dem",
      titleHighlight: "VIP",
      title2: "Newsletter Bei",
      description: "Erhalten Sie exklusive Casino-Boni, Krypto-Tipps und VIP-Angebote.",
      placeholder: "ihre@email.de",
      button: "VIP Beitreten",
      success: "Sie sind dabei! Prüfen Sie Ihren Posteingang.",
      noSpam: "Kein Spam, niemals. Jederzeit abmelden.",
    },
    footer: {
      tagline: "Die führende Anlaufstelle für Krypto-Glücksspiel-Ratgeber und verantwortungsvolles Gaming.",
      navigation: "Navigation",
      resources: "Ressourcen",
      legal: "Rechtliches",
      home: "Startseite",
      aboutUs: "Über Uns",
      contact: "Kontakt",
      cryptoGuide: "Krypto Casino Ratgeber",
      blog: "Blog",
      faq: "FAQ",
      privacy: "Datenschutz",
      terms: "Nutzungsbedingungen",
      responsibleGambling: "Verantwortungsvolles Spielen",
      affiliateDisclosure: "Affiliate Offenlegung",
      company: "Unternehmen",
      ourTeam: "Unser Expertenteam",
      methodology: "So Bewerten Wir",
      editorialGuidelines: "Redaktionelle Richtlinien",
      copyright: "CryptoVIP Club. Alle Rechte vorbehalten.",
      gamblingWarning: "Glücksspiel birgt Risiken. Bitte spielen Sie verantwortungsvoll. 18+",
      disclaimer: "Diese Website enthält Affiliate-Links.",
    },
  },

  // ============ DUTCH (NETHERLANDS) ============
  nl: {
    meta: {
      title: "CryptoVIP Club | Eerste VIP Deal Onderhandelaars Crypto Casino's",
      description: "Wij onderhandelen VIP-deals met top crypto casino's voor jou. Persoonlijke cashback tarieven, exclusieve bonuscodes en op maat gemaakte VIP-voordelen. 100% gratis service.",
      keywords: "crypto casino VIP, casino onderhandeling, VIP bonus codes, gepersonaliseerde casino deals, crypto cashback",
    },
    header: {
      topCasinos: "Top Casino's",
      guides: "Gidsen",
      faq: "FAQ",
      blog: "Blog",
      joinVip: "Word VIP Lid",
    },
    hero: {
      badge: "'S WERELDS EERSTE VIP CASINO ONDERHANDELAARS",
      title1: "Wij Onderhandelen Met Casino's",
      titleHighlight: "Zodat Jij Dat Niet Hoeft",
      subtitle: "Vertel ons welk cashback-percentage je wilt, welke VIP-voordelen je verdient, en wij onderhandelen direct met top crypto casino's. Geen tussenkosten. Alleen betere deals.",
      exploreCasinos: "Bekijk Hoe Het Werkt",
      readGuides: "VIP Voordelen",
      trustBadges: {
        partnerships: "Directe Casino Partnerschappen",
        vipDeals: "Gepersonaliseerde VIP Deals",
        freeService: "100% Gratis Service"
      },
    },
    howItWorks: {
      sectionTitle: "Hoe Wij Je",
      sectionHighlight: "Betere Deals Bezorgen",
      step1Title: "Vertel Ons Wat Je Wilt",
      step1Desc: "Deel je gewenste cashback-percentage, bonusvoorkeuren en VIP-voordelen. Hoe meer details, hoe beter de deal.",
      step2Title: "Wij Onderhandelen Voor Jou",
      step2Desc: "Ons team neemt direct contact op met casino VIP-managers. We gebruiken ons netwerk om exclusieve voorwaarden te krijgen.",
      step3Title: "Ontvang Je Persoonlijke Deal",
      step3Desc: "Ontvang je gepersonaliseerde VIP-pakket met exclusieve bonussen, hogere limieten en voordelen.",
      whyTitle: "Waarom Via Ons Onderhandelen?",
      directAccess: "Directe Toegang",
      directAccessDesc: "Wij hebben directe relaties met casino VIP-managers",
      negotiationPower: "Onderhandelingskracht",
      negotiationPowerDesc: "Ons volume geeft ons hefboomwerking",
      industryExpertise: "Industrie Expertise",
      industryExpertiseDesc: "Wij weten welke deals mogelijk zijn",
      zeroCost: "Geen Kosten",
      zeroCostDesc: "100% gratis onderhandelingsservice",
      responseTime: "Gemiddelde reactietijd",
      startNegotiating: "Start Onderhandeling"
    },
    quiz: {
      badge: "Gepersonaliseerde Quiz • 60 seconden",
      title: "Vind Jouw",
      titleHighlight: "Perfecte Deal",
      description: "Beantwoord 4 snelle vragen en we laten je zien welk type VIP je bent.",
      highRoller: "High Roller",
      highRollerDesc: "Grote inzetten, grote beloningen",
      casualPro: "Casual Pro",
      casualProDesc: "Slimme speelwijze, stabiele winsten",
      tournamentKing: "Toernooi Koning",
      tournamentKingDesc: "Competitie liefhebber",
      startQuiz: "Start de Quiz",
      trustNote: "100% gratis • Geen verplichtingen • Je gegevens zijn veilig"
    },
    vipBenefits: {
      sectionTitle: "Waarom Lid Worden van de",
      sectionHighlight: "VIP Club",
      bonusCodes: "Exclusieve Bonuscodes",
      bonusCodesDesc: "Krijg toegang tot bonuscodes die nergens anders beschikbaar zijn.",
      earlyAccess: "Vroege Toegang",
      earlyAccessDesc: "Wees de eerste die op de hoogte is van nieuwe crypto casino's.",
      vipDeals: "Alleen-Leden VIP Deals",
      vipDealsDesc: "Exclusieve onderhandelingen met casino VIP-managers.",
      community: "Community & Tips",
      communityDesc: "Word lid van onze privé-community.",
      alerts: "Casino Alerts",
      alertsDesc: "Directe meldingen over nieuwe bonussen.",
      support: "Prioriteits Ondersteuning",
      supportDesc: "Directe lijn naar ons team.",
      joinCta: "Sluit je aan bij 45.000+ Club Leden",
      joinButton: "Word Gratis Lid"
    },
    crypto: {
      title: "Ondersteunde Cryptocurrencies"
    },
    stats: {
      title: "Vertrouwd door Duizenden Spelers",
      provablyFair: "Provably Fair Geverifieerd",
      instantWithdrawals: "Directe Crypto Opnames",
      licensedOnly: "Alleen Gelicenseerde Casino's"
    },
    guides: {
      subtitle: "Kennisbank",
      title: "Crypto Casino",
      titleHighlight: "Gidsen",
      description: "Experthandleidingen en strategieën voor crypto casino spelers."
    },
    spokes: {
      subtitle: "Laatste Artikelen",
      title: "Van de",
      titleHighlight: "Blog",
      description: "Expert inzichten en strategieën van onze blog."
    },
    faq: {
      subtitle: "Vragen?",
      title: "Veelgestelde",
      titleHighlight: "Vragen",
    },
    blog: {
      subtitle: "Laatste Gidsen",
      title: "Crypto Casino",
      titleHighlight: "Artikelen",
      readMore: "Lees Artikel",
      viewAll: "Bekijk Alle Gidsen",
      minRead: "min lezen",
      description: "Experthandleidingen en strategieën voor crypto casino spelers."
    },
    newsletter: {
      title: "Schrijf je in voor de",
      titleHighlight: "VIP",
      title2: "Nieuwsbrief",
      description: "Ontvang exclusieve casino bonussen, crypto tips en VIP-only deals.",
      placeholder: "jouw@email.nl",
      button: "Word VIP",
      success: "Je bent binnen! Check je inbox.",
      noSpam: "Geen spam, ooit. Uitschrijven kan altijd.",
    },
    footer: {
      tagline: "De toonaangevende bestemming voor crypto gokken gidsen en verantwoord gamen.",
      navigation: "Navigatie",
      resources: "Bronnen",
      legal: "Juridisch",
      home: "Home",
      aboutUs: "Over Ons",
      contact: "Contact",
      cryptoGuide: "Crypto Casino Gidsen",
      blog: "Blog",
      faq: "FAQ",
      privacy: "Privacybeleid",
      terms: "Algemene Voorwaarden",
      responsibleGambling: "Verantwoord Gokken",
      affiliateDisclosure: "Affiliate Disclosure",
      company: "Bedrijf",
      ourTeam: "Ons Expert Team",
      methodology: "Hoe Wij Beoordelen",
      editorialGuidelines: "Redactionele Richtlijnen",
      copyright: "CryptoVIP Club. Alle rechten voorbehouden.",
      gamblingWarning: "Gokken brengt risico met zich mee. Gok verantwoord. 18+",
    },
  },

  // ============ DANISH (DENMARK) ============
  da: {
    meta: {
      title: "CryptoVIP Club | Første VIP Deal Forhandlere Krypto Casinoer",
      description: "Vi forhandler VIP-aftaler med top krypto casinoer for dig. Personlige cashback-satser, eksklusive bonuskoder og skræddersyede VIP-fordele. 100% gratis service.",
      keywords: "krypto casino VIP, casino forhandling, VIP bonus koder, personlige casino tilbud, krypto cashback",
    },
    header: {
      topCasinos: "Top Casinoer",
      guides: "Guides",
      faq: "FAQ",
      blog: "Blog",
      joinVip: "Bliv VIP Medlem",
    },
    hero: {
      badge: "VERDENS FØRSTE VIP CASINO FORHANDLERE",
      title1: "Vi Forhandler Med Casinoer",
      titleHighlight: "Så Du Ikke Behøver",
      subtitle: "Fortæl os hvilken cashback-sats du ønsker, hvilke VIP-fordele du fortjener, og vi forhandler direkte med top krypto casinoer. Ingen mellemmandsgebyrer. Kun bedre tilbud.",
      exploreCasinos: "Se Hvordan Det Virker",
      readGuides: "VIP Fordele",
      trustBadges: {
        partnerships: "Direkte Casino Partnerskaber",
        vipDeals: "Personaliserede VIP-tilbud",
        freeService: "100% Gratis Service"
      },
    },
    howItWorks: {
      sectionTitle: "Hvordan Vi Får Dig",
      sectionHighlight: "Bedre Tilbud",
      step1Title: "Fortæl Os Hvad Du Vil Have",
      step1Desc: "Del din ønskede cashback-sats, bonuspræferencer og VIP-fordele. Jo flere detaljer, jo bedre tilbud.",
      step2Title: "Vi Forhandler For Dig",
      step2Desc: "Vores team kontakter casino VIP-managers direkte. Vi bruger vores netværk til at sikre eksklusive vilkår.",
      step3Title: "Få Din Personlige Deal",
      step3Desc: "Modtag din personaliserede VIP-pakke med eksklusive bonusser, højere grænser og fordele.",
      whyTitle: "Hvorfor Forhandle Gennem Os?",
      directAccess: "Direkte Adgang",
      directAccessDesc: "Vi har direkte relationer med casino VIP-managers",
      negotiationPower: "Forhandlingsstyrke",
      negotiationPowerDesc: "Vores volumen giver os løftestang",
      industryExpertise: "Brancheekspertise",
      industryExpertiseDesc: "Vi ved hvilke tilbud der er mulige",
      zeroCost: "Ingen Omkostninger",
      zeroCostDesc: "100% gratis forhandlingsservice",
      responseTime: "Gennemsnitlig svartid",
      startNegotiating: "Start Forhandling"
    },
    quiz: {
      badge: "Personaliseret Quiz • 60 sekunder",
      title: "Find Din",
      titleHighlight: "Perfekte Deal",
      description: "Besvar 4 hurtige spørgsmål og vi viser dig hvilken type VIP du er.",
      highRoller: "High Roller",
      highRollerDesc: "Store indsatser, store belønninger",
      casualPro: "Casual Pro",
      casualProDesc: "Smart spil, stabile gevinster",
      tournamentKing: "Turnerings Konge",
      tournamentKingDesc: "Konkurrence elsker",
      startQuiz: "Start Quiz",
      trustNote: "100% gratis • Ingen forpligtelse • Dine data er sikre"
    },
    vipBenefits: {
      sectionTitle: "Hvorfor Blive Medlem af",
      sectionHighlight: "VIP Club",
      bonusCodes: "Eksklusive Bonuskoder",
      bonusCodesDesc: "Få adgang til bonuskoder der ikke er tilgængelige andre steder.",
      earlyAccess: "Tidlig Adgang",
      earlyAccessDesc: "Vær den første der hører om nye krypto casinoer.",
      vipDeals: "Kun-Medlemmer VIP-tilbud",
      vipDealsDesc: "Eksklusive forhandlinger med casino VIP-managers.",
      community: "Fællesskab & Tips",
      communityDesc: "Bliv en del af vores private fællesskab.",
      alerts: "Casino Alerts",
      alertsDesc: "Øjeblikkelige notifikationer om nye bonusser.",
      support: "Prioritets Support",
      supportDesc: "Direkte linje til vores team.",
      joinCta: "Bliv En Del af 45.000+ Club Medlemmer",
      joinButton: "Bliv Gratis Medlem"
    },
    crypto: {
      title: "Understøttede Kryptovalutaer"
    },
    stats: {
      title: "Betroet af Tusindvis af Spillere",
      provablyFair: "Provably Fair Verificeret",
      instantWithdrawals: "Øjeblikkelige Krypto Udbetalinger",
      licensedOnly: "Kun Licenserede Casinoer"
    },
    guides: {
      subtitle: "Vidensbase",
      title: "Krypto Casino",
      titleHighlight: "Guides",
      description: "Ekspertguides og strategier for krypto casino spillere."
    },
    spokes: {
      subtitle: "Seneste Artikler",
      title: "Fra",
      titleHighlight: "Bloggen",
      description: "Ekspertindsigter og strategier fra vores blog."
    },
    faq: {
      subtitle: "Har du Spørgsmål?",
      title: "Ofte Stillede",
      titleHighlight: "Spørgsmål",
    },
    blog: {
      subtitle: "Seneste Guides",
      title: "Krypto Casino",
      titleHighlight: "Artikler",
      readMore: "Læs Artikel",
      viewAll: "Se Alle Guides",
      minRead: "min læsning",
      description: "Ekspertguides og strategier for krypto casino spillere."
    },
    newsletter: {
      title: "Tilmeld dig",
      titleHighlight: "VIP",
      title2: "Nyhedsbrevet",
      description: "Få eksklusive casino bonusser, krypto tips og VIP-tilbud.",
      placeholder: "din@email.dk",
      button: "Bliv VIP",
      success: "Du er med! Tjek din indbakke.",
      noSpam: "Ingen spam, nogensinde. Afmeld når som helst.",
    },
    footer: {
      tagline: "Danmarks førende destination for krypto gambling guides og ansvarligt spil.",
      navigation: "Navigation",
      resources: "Ressourcer",
      legal: "Juridisk",
      home: "Hjem",
      aboutUs: "Om Os",
      contact: "Kontakt Os",
      cryptoGuide: "Krypto Casino Guider",
      blog: "Blog",
      faq: "FAQ",
      privacy: "Privatlivspolitik",
      terms: "Servicevilkår",
      responsibleGambling: "Ansvarligt Spil",
      affiliateDisclosure: "Affiliate Oplysning",
      company: "Virksomhed",
      ourTeam: "Vores Ekspertteam",
      methodology: "Sådan Anmelder Vi",
      editorialGuidelines: "Redaktionelle Retningslinjer",
      copyright: "CryptoVIP Club. Alle rettigheder forbeholdes.",
      gamblingWarning: "Gambling indebærer risiko. Spil venligst ansvarligt. 18+",
    },
  },

  // ============ ENGLISH (CANADA) ============
  "en-ca": {
    meta: {
      title: "CryptoVIP Club | First VIP Deal Negotiators Canada",
      description: "We negotiate VIP deals with top crypto casinos for Canadians. Get personalized cashback rates, exclusive bonus codes, and custom VIP perks. Free service.",
      keywords: "crypto casino VIP canada, casino negotiation, VIP bonus codes canada, personalized casino deals, crypto cashback",
    },
    header: {
      topCasinos: "Top Casinos",
      guides: "Guides",
      faq: "FAQ",
      blog: "Blog",
      joinVip: "Join VIP Club",
    },
    hero: {
      badge: "WORLD'S FIRST VIP CASINO NEGOTIATORS",
      title1: "We Negotiate With Casinos",
      titleHighlight: "So You Don't Have To",
      subtitle: "Tell us the cashback rate you want, the VIP perks you deserve, and we'll negotiate directly with top crypto casinos. No middleman fees. Just better deals.",
      exploreCasinos: "See How It Works",
      readGuides: "VIP Benefits",
      trustBadges: {
        partnerships: "Direct Casino Partnerships",
        vipDeals: "Personalized VIP Deals",
        freeService: "100% Free Service"
      },
    },
    howItWorks: {
      sectionTitle: "How We Get You",
      sectionHighlight: "Better Deals",
      step1Title: "Tell Us What You Want",
      step1Desc: "Share your desired cashback rate, bonus preferences, and VIP perks. The more details, the better deal.",
      step2Title: "We Negotiate For You",
      step2Desc: "Our team contacts casino VIP managers directly. We leverage our network to secure exclusive terms.",
      step3Title: "Get Your Custom Deal",
      step3Desc: "Receive your personalized VIP package with exclusive bonuses, higher limits, and perks.",
      whyTitle: "Why Negotiate Through Us?",
      directAccess: "Direct Access",
      directAccessDesc: "We have direct relationships with casino VIP managers",
      negotiationPower: "Negotiation Power",
      negotiationPowerDesc: "Our volume gives us leverage individual players don't have",
      industryExpertise: "Industry Expertise",
      industryExpertiseDesc: "We know what deals are possible",
      zeroCost: "Zero Cost",
      zeroCostDesc: "100% free Negotiation Service",
      responseTime: "Average response time",
      startNegotiating: "Start Negotiating"
    },
    quiz: {
      badge: "Personalized Quiz • 60 seconds",
      title: "Find Your",
      titleHighlight: "Perfect Deal",
      description: "Answer 4 quick questions and we'll show you what type of VIP you are.",
      highRoller: "High Roller",
      highRollerDesc: "Big bets, big rewards",
      casualPro: "Casual Pro",
      casualProDesc: "Smart plays, steady wins",
      tournamentKing: "Tournament King",
      tournamentKingDesc: "Competition lover",
      startQuiz: "Start the Quiz",
      trustNote: "100% free • No commitment • Your data is safe"
    },
    vipBenefits: {
      sectionTitle: "Why Join the",
      sectionHighlight: "VIP Club",
      bonusCodes: "Exclusive Bonus Codes",
      bonusCodesDesc: "Get access to bonus codes not available anywhere else.",
      earlyAccess: "Early Access",
      earlyAccessDesc: "Be the first to know about new crypto casinos.",
      vipDeals: "Members-Only VIP Deals",
      vipDealsDesc: "Exclusive negotiations with casino VIP managers.",
      community: "Community & Tips",
      communityDesc: "Join our private community.",
      alerts: "Casino Alerts",
      alertsDesc: "Instant notifications about new bonuses.",
      support: "Priority Support",
      supportDesc: "Direct line to our team.",
      joinCta: "Join 45,000+ Club Members",
      joinButton: "Join Free Now"
    },
    crypto: {
      title: "Supported Cryptocurrencies"
    },
    stats: {
      title: "Trusted by Thousands of Players",
      provablyFair: "Provably Fair Verified",
      instantWithdrawals: "Instant Crypto Withdrawals",
      licensedOnly: "Licensed Casinos Only"
    },
    guides: {
      subtitle: "Knowledge Base",
      title: "Crypto Casino",
      titleHighlight: "Guides",
      description: "Expert tutorials and strategies for Canadian crypto casino players."
    },
    spokes: {
      subtitle: "Latest Articles",
      title: "From the",
      titleHighlight: "Blog",
      description: "Expert insights and strategies from our blog."
    },
    faq: {
      subtitle: "Got Questions?",
      title: "Frequently Asked",
      titleHighlight: "Questions",
    },
    blog: {
      subtitle: "Latest Guides",
      title: "Crypto Casino",
      titleHighlight: "Articles",
      readMore: "Read Article",
      viewAll: "View All Guides",
      minRead: "min read",
      description: "Expert tutorials and strategies for Canadian crypto casino players."
    },
    newsletter: {
      title: "Join the",
      titleHighlight: "VIP",
      title2: "Newsletter",
      description: "Get exclusive casino bonuses, crypto tips, and VIP-only deals for Canadian players.",
      placeholder: "your@email.ca",
      button: "Join VIP",
      success: "You're in! Check your inbox.",
      noSpam: "No spam, ever. Unsubscribe anytime.",
    },
    footer: {
      tagline: "Canada's premier destination for crypto gambling guides and responsible gaming.",
      navigation: "Navigation",
      resources: "Resources",
      legal: "Legal",
      home: "Home",
      aboutUs: "About Us",
      contact: "Contact Us",
      cryptoGuide: "Crypto Casino Guides",
      blog: "Blog",
      faq: "FAQ",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      responsibleGambling: "Responsible Gambling",
      affiliateDisclosure: "Affiliate Disclosure",
      company: "Company",
      ourTeam: "Our Expert Team",
      methodology: "How We Review",
      editorialGuidelines: "Editorial Guidelines",
      copyright: "CryptoVIP Club. All rights reserved.",
      gamblingWarning: "Gambling involves risk. Please gamble responsibly. 19+ in most provinces.",
    },
  },
};

// Helper function to get translation
export const getTranslation = (lang) => {
  return translations[lang] || translations.en;
};

// Helper to get language info by code
export const getLanguageInfo = (code) => {
  return SUPPORTED_LANGUAGES.find(l => l.code === code) || SUPPORTED_LANGUAGES[0];
};

// Helper to get language by path
export const getLanguageByPath = (path) => {
  const cleanPath = path.split("?")[0].split("#")[0];
  const lang = SUPPORTED_LANGUAGES.find(l => l.path === cleanPath || cleanPath.startsWith(l.path + "/"));
  return lang || SUPPORTED_LANGUAGES[0];
};

export default translations;
